function initAnimation() {
    // console.log('init animations');
    initParallax();
    initToShow();
}

loadVideo();
$(function(){
    initCarousel();
    initVideo();
    setIntersections();
    initAnimation();
    
    if($('.js-twitter').length){getTwitter();}
    if($('.js-insta').length){getInsta();}
    if($('.js-facebook').length){getFacebook();}

    $window.on('scroll', function(e){
        e.preventDefault();
        wt = $window.scrollTop();
        wb = wt + wh; 
        ft = $footer.offset().top;
    });

    $window.on('resize', function(){
        wh = $window.height();
        ww = $window.width();
        wt = $window.scrollTop();
        wb = wt + wh;
        wRatio = ww/wh; 
        ft = $footer.offset().top;
    });
});
